module.exports = __webpack_public_path__ + "img/phone-login.adb91fcb.png";